import React from 'react'
import './Footer.css'
import { Link } from 'gatsby'
import SVGIcon from '../components/SVGIcon'

export default () => (
  <div>
    <h2 className="taCenter">
      Follow us at{' '}
      <br />
      <a href="https://www.instagram.com/citychain_germany/">
        <SVGIcon src="/images/instagram.svg" />
      </a>
      <a href="https://twitter.com/citychainger">
        <SVGIcon src="/images/twitter.svg" />
      </a>
      <a href="https://www.facebook.com/citychaingermany/">
        <SVGIcon src="/images/facebook.svg" />
      </a>
      <a href="https://wa.me/491727631246">
        <SVGIcon src="/images/whatsapp.svg" />
      </a>
      <a href="https://www.linkedin.com/company/citychain">
        <SVGIcon src="/images/linkedin.svg" />
      </a>
    </h2>
    <br />
    <footer className="footer">
      <div className="container taLeft">
        <span>
          © Copyright CityChain {new Date().getFullYear()} All rights reserved. 
        </span>
        <br />
        <span>
          <Link to="/legal/">Legal</Link>
        </span>
        <br />
        <span>
          <Link to="/privacy/">Privacy Policy</Link>
        </span>
      </div>
    </footer>
  </div>
)
